import { createAPI } from '@common'
//
export default {
  getRoot: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0spput', 'get', config, vconfig),
  getSubs: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0tvc', 'get', config),
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.xjsf0f60benjo0qfsnjttjpot0bdujpot0gpmefs', 'get', config)
}
